"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var moment_1 = __importDefault(require("moment"));

function validateInquiry(inquiry) {
  var errors = [];

  if (!inquiry.date) {
    errors.push("date");
  }

  if (!inquiry.startTime) {
    errors.push("startTime");
  }

  if (!inquiry.length) {
    errors.push("length");
  }

  if (!inquiry.guests) {
    errors.push("guests");
  }

  if (!inquiry.spaces) {
    errors.push("spaces");
  }

  if (inquiry.status !== "INQUIRY") {
    errors.push("status");
  }

  var validation = {
    valid: errors.length === 0
  };

  if (errors.length > 0) {
    validation.errors = errors;
  }

  return validation;
}

exports.validateInquiry = validateInquiry;

function validateTextMessage(textMessage) {
  var errors = [];

  if (!textMessage.time) {
    errors.push("time");
  }

  if (!textMessage.message) {
    errors.push("message");
  }

  if (!textMessage.from) {
    errors.push("from");
  }

  if (textMessage.type !== "MESSAGE") {
    errors.push("type");
  }

  var validation = {
    valid: errors.length == 0
  };

  if (errors.length > 0) {
    validation.errors = errors;
  }

  return validation;
}

exports.validateTextMessage = validateTextMessage;

exports.generateTimeOptions = function () {
  var x = 30;
  var times = [];
  var tt = 0;
  var ap = [" AM", " PM"];

  for (var i = 0; tt < 24 * 60; i++) {
    var hh = Math.floor(tt / 60);
    var mm = tt % 60;
    times[i] = (hh % 12 == 0 ? 12 : hh % 12) + ":" + ("0" + mm).slice(-2) + ap[Math.floor(hh / 12)];
    tt = tt + x;
  }

  return times.map(function (time) {
    return {
      name: moment_1.default(time, "h:mm A").format("HH:mm"),
      title: time
    };
  });
};

exports.generateDurationOptions = function () {
  var times = [];

  for (var i = 0; i < 12; i++) {
    var hours = (i + 1) / 2;
    times.push({
      name: "" + hours,
      title: hours + " hours"
    });
  }

  return times;
};